<template>
  <v-dialog
    v-model="dialog.open"
    class="dialog"
    scrollable
    :width="isMobile ? 'auto' : '530'"
    :fullscreen="isMobile"
    @click:outside="dialogClose"
  >
    <v-card class="dialog-create-address">
      <v-card-title class="dialog-title">
        {{ dialog.type === 'create' ? '新增常用地址' : '' }}
        {{ dialog.type === 'edit' ? '編輯常用地址' : '' }}
        <i
          class="close icon-close"
          @click="dialogCancel"
        />
      </v-card-title>
      <v-card-text class="dialog-content">
        <v-form
          ref="dialogForm"
          v-model="dialog.valid"
          class="content-form"
        >
          <div class="item">
            <p class="label">
              聯絡人
            </p>
            <v-text-field
              v-model="dialog.data.name"
              class="input"
              label="請輸入姓名"
              type="text"
              maxlength="20"
              single-line
              outlined
              hide-details="auto"
              :rules="dialog.data.nameRule"
              @keypress.enter.native.prevent="dialogSubmit"
            />
          </div>
          <div class="item">
            <p class="label">
              連絡電話
            </p>
            <v-text-field
              v-model="dialog.data.phone"
              class="input"
              label="請輸入手機或市話（市話請加區碼）"
              type="tel"
              maxlength="15"
              single-line
              outlined
              hide-details="auto"
              :rules="dialog.data.phoneRule"
              @keypress.enter.native.prevent="dialogSubmit"
            />
          </div>
          <div class="item city half">
            <p class="label">
              縣市
            </p>
            <v-select
              v-model="dialog.data.city"
              class="select"
              :items="cityArea"
              placeholder="請選擇縣市"
              item-text="City"
              item-value="City"
              outlined
              return-object
              hide-details
              @change="changeCity"
            />
          </div>
          <div class="item area half">
            <p class="label">
              行政區
            </p>
            <v-select
              v-model="dialog.data.area"
              class="select"
              :items="dialog.data.city ? dialog.data.city.Area : []"
              placeholder="請選擇行政區"
              item-text="Area"
              item-value="Area"
              outlined
              return-object
              hide-details
            />
          </div>
          <div class="item address">
            <p class="label">
              詳細地址
            </p>
            <v-text-field
              v-model="dialog.data.address"
              class="input"
              label="請輸入詳細地址（里道路、街名、巷弄號及樓層）"
              type="text"
              maxlength="70"
              single-line
              outlined
              hide-details="auto"
              :rules="dialog.data.addressRule"
              @keypress.enter.native.prevent="dialogSubmit"
            />
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions class="dialog-actions">
        <v-btn
          v-if="dialog.type === 'edit'"
          class="btn"
          depressed
          outlined
          color="primary"
          @click="dialogCancel"
        >
          取消
        </v-btn>
        <v-btn
          class="btn"
          depressed
          color="primary"
          :loading="dialog.btnIsLoading"
          @click="dialogSubmit"
        >
          完成
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    open: Boolean,
    type: String,
    address: {
      type: Object,
      default: () => {}
    },
    addressList: Array
  },
  data () {
    return {
      isMobile: null,
      dialog: {
        open: false,
        type: '',
        btnIsLoading: false,
        data: {
          name: '',
          nameRule: [() => true],
          phone: '',
          phoneRule: [() => true],
          city: {},
          area: {},
          address: '',
          addressRule: [() => true],
          IsDefault: false,
          AddressId: null
        }
      }
    }
  },
  computed: {
    cityArea () {
      return this.$store.state.cityArea
    }
  },
  watch: {
    open (val) {
      this.dialog.open = val
      if (!val) return
      this.$set(this.dialog.data, 'city', this.$store.state.cityArea[0])
      this.$set(this.dialog.data, 'area', this.$store.state.cityArea[0].Area[0])
      if (this.address) {
        this.dialog.data = {
          ...this.dialog.data,
          ...this.address
        }
      }
    },
    type (val) {
      this.dialog.type = val
    }
  },
  async mounted () {
    this.isMobile = screen.width <= 768
    this.dialog.open = this.open
    this.dialog.type = this.type
    await this.$store.dispatch('getCityArea')
    this.$set(this.dialog.data, 'city', this.$store.state.cityArea[0])
    this.$set(this.dialog.data, 'area', this.$store.state.cityArea[0].Area[0])
  },
  methods: {
    dialogSubmit () {
      if (this.dialog.btnIsLoading) return
      this.dialog.btnIsLoading = true
      switch (this.dialog.type) {
        case 'create':
          this.createAddress()
          break
        case 'edit':
          this.editAddress()
          break
        default:
          break
      }
    },
    async setDialogRule () {
      const setNameRule = async () => {
        const nameRequired = value => !!value || '請輸入姓名'
        this.$set(this.dialog.data, 'nameRule', [nameRequired])
      }
      const setPhoneRule = async () => {
        const phoneRules = value => {
          const errorText = '聯絡電話格式錯誤'
          if (!value) return errorText
          // 電話必為 9~15 碼，且為 0 開頭 (不能886)
          if (value?.length < 9 || value.slice(0, 1) !== '0') return errorText
          // 手機驗證：09 開頭，10 碼皆為數字
          if (value.slice(0, 2) === '09' && !(/^\d{10}$/).test(value)) return errorText
          // 市話驗證：非 09 開頭，允許數字、*、#
          if (value.slice(0, 2) !== '09' && !(/^[0-9*#]+$/).test(value)) return errorText
          return true
        }
        this.$set(this.dialog.data, 'phoneRule', [phoneRules])
      }
      const setAddressRule = async () => {
        const addressRequired = value => !!value || '請輸入詳細地址'
        this.$set(this.dialog.data, 'addressRule', [addressRequired])
      }
      await setNameRule()
      await setPhoneRule()
      await setAddressRule()
    },
    async createAddress () {
      await this.setDialogRule()

      if (!this.$refs.dialogForm.validate()) {
        this.dialog.btnIsLoading = false
        return
      }
      const dialogData = this.dialog.data
      const postData = {
        Name: dialogData.name,
        Phone: dialogData.phone,
        City: dialogData.city.City,
        Area: dialogData.area.Area,
        PostNumber: dialogData.area.Zip5,
        Address: dialogData.address,
        IsDefault: this.addressList.length === 0 ? 1 : 0
      }
      const { data } = await this.$axios.post('/api/KingnetAccount/Address', postData)
        .catch(error => {
          this.$store.dispatch('toast', {
            isOpen: true,
            text: '新增失敗',
            type: 'error'
          })
          this.dialog.btnIsLoading = false
        })
      postData.AddressId = data.Data
      this.$emit('create', postData)
      this.$store.dispatch('toast', {
        isOpen: true,
        text: '新增成功',
        type: 'success'
      })
      this.dialog.btnIsLoading = false
      this.dialogClose()
      this.resetDialog()
    },
    async editAddress () {
      await this.setDialogRule()

      if (!this.$refs.dialogForm.validate()) {
        this.dialog.btnIsLoading = false
        return
      }
      const dialogData = this.dialog.data
      const postData = {
        AddressId: dialogData.AddressId,
        Name: dialogData.name,
        Phone: dialogData.phone,
        City: dialogData.city.City,
        Area: dialogData.area.Area,
        PostNumber: dialogData.area.Zip5,
        Address: dialogData.address,
        IsDefault: dialogData.IsDefault
      }
      const { data } = await this.$axios.put('/api/KingnetAccount/Address', postData)
        .catch(error => {
          this.$store.dispatch('toast', {
            isOpen: true,
            text: '編輯失敗',
            type: 'error'
          })
          this.dialog.btnIsLoading = false
        })
      this.$store.dispatch('toast', {
        isOpen: true,
        text: '編輯成功',
        type: 'success'
      })

      this.dialog.btnIsLoading = false
      this.resetDialog()
      this.$emit('edit', { AddressId: dialogData.AddressId, data: postData })
      this.dialogClose()
    },
    async changeCity (city) {
      this.dialog.data.area = city.Area[0]
    },
    dialogCancel () {
      this.resetDialog()
      this.dialogClose()
    },
    resetDialog () {
      this.$refs.dialogForm.reset()
      this.$refs.dialogForm.resetValidation()
    },
    dialogClose () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-create-address {
  .dialog-title {
    position: relative;
    padding-top: 30px;
    padding-bottom: 20px;
    padding-left: var(--safe-area-inset-left);
    padding-right: var(--safe-area-inset-right);
    justify-content: center;
    font-size: pxTorem(17px);
    line-height: pxTorem(24px);
    i.close {
      position: absolute;
      padding: 10px;
      right: 20px;
      right: calc(20px + var(--safe-area-inset-right));
      background-color: #fff;
      color: #888;
      z-index: 1;
      font-size: pxTorem(20px);
      cursor: pointer;
    }
  }
  .dialog-content {
    padding-top: 30px;
    padding-bottom: 35px;
    .content-form {
      display: flex;
      flex-wrap: wrap;
    }
    .item {
      flex: none;
      width: 100%;
      & + .item {
        margin-top: 17px;
      }
      p.label {
        font-weight: bold;
        margin-bottom: 8px;
      }
    }
    .item.half {
      flex: 1;
      & + .item.half {
        margin-left: 10px;
      }
    }
    ::v-deep {
      .v-input__slot {
        border-color: #D2D2D2;
      }
    }
  }
  .dialog-actions {
    display: flex;
    text-align: center;
    justify-content: center;
    padding-bottom: 30px;
    padding-bottom: max(30px, calc(10px + var(--safe-area-inset-bottom)));
    .btn {
      // flex: 1;
      height: auto;
      padding: 10px;
      ::v-deep {
        span {
          font-size: pxTorem(17px);
          line-height: pxTorem(24px);
        }
      }
    }
  }
}

/** 手機 */
@media screen and (max-width: $mobileWidth) {
  .dialog-create-address {
    .dialog-title {
      position: relative;
      padding: 30px 10px;
      padding-top: max(30px, calc(10px + var(--safe-area-inset-top)));
      padding-left: calc(10px + var(--safe-area-inset-left));
      padding-right: calc(10px + var(--safe-area-inset-right));
      h2 {
        margin-top: 15px;
        font-size: pxTorem(16px);
        line-height: pxTorem(22px);
      }
      i.close {
        top: 15px;
        top: calc(15px + var(--safe-area-inset-top));
      }
    }
    .dialog-content {
      padding: 35px 15px 60px;
      padding-left: max(15px, calc(10px + var(--safe-area-inset-left)));
      padding-right: max(15px, calc(10px + var(--safe-area-inset-right)));
      .item {
        p.label {
          font-size: pxTorem(16px);
          line-height: pxTorem(22px);
        }
      }
      ::v-deep {
        .v-input__slot {
          $inputHeight: 44px;
          min-height: $inputHeight;
          .v-label {
            top: 0;
            height: $inputHeight;
            line-height: $inputHeight;
          }
        }
      }
    }
    .dialog-actions {
      // display: block;
      display: flex;
      padding: 0;
      padding-left: max(30px, calc(10px + var(--safe-area-inset-left)));
      padding-right: max(30px, calc(10px + var(--safe-area-inset-right)));
      padding-bottom: calc(10px + var(--safe-area-inset-bottom));
      .btn {
        flex: 1;
        padding: 10px 44px;
        &:first-child {
          margin-right: 10px;
        }
      }
    }
  }
}
/** 手機以上 */
@media screen and (min-width: $mobileWidth) {
  .dialog-create-address {
    .dialog-title {
      padding-bottom: 20px;
      font-size: pxTorem(17px);
      line-height: pxTorem(24px);
    }
    .dialog-content {
      width: calc(100% - 30px * 2);
      width: calc(100% - 20px * 2 - var(--safe-area-inset-left) - var(--safe-area-inset-right));
      margin-left: auto;
      margin-right: auto;
      border-top: 2px solid $mainColor;
      .item {
        p.label {
          font-size: pxTorem(17px);
          line-height: pxTorem(24px);
        }
      }
    }
    .dialog-actions {
      padding-left: 30px;
      padding-right: 30px;
      padding-bottom: 30px;
      padding-bottom: max(30px, calc(10px + var(--safe-area-inset-bottom)));
      .btn {
        & + .btn {
          margin-left: 30px;
        }
        padding: 10px 75px;
        height: auto;
        ::v-deep {
          span {
            font-size: pxTorem(17px);
            line-height: pxTorem(24px);
          }
        }
      }
    }
  }
}
</style>
